import { ChangePasswordSuperAdmin } from '../../components/superAdmin/changePassword.component';

export const SuperAdminChangePasswordPage = () => {
    return (
      <div className="row gx-0">
        <div className="col-12 m-2">
          <div className="d-flex flex-column ms-1 px-1">
            <p className="content-header">
              Change Password
            </p>
            <ChangePasswordSuperAdmin/>
          </div>
        </div>
      </div>
    );
  };
  